/**  teacher actions constants */
export const SET_LIST_SCHOOL_YEAR = 'school_year/SET_LIST_SCHOOL_YEAR';